import { useMemo } from 'react'
import { useLoading, useServerError } from 'shared/hooks'
import { useGetFollowedProjectsQuery } from '../graphql/getFollowedProjects.types'
import { IFollowedProjects, TNotifications } from '../types'

export const useFollowedProjects = (zoneId: string, country: string, notifications: TNotifications[]) => {
  const { data: followedArtistsResponse, loading, error } = useGetFollowedProjectsQuery({
    fetchPolicy: 'no-cache',
    skip: !zoneId || !country,
    variables: {
      offset: 0,
      limit: 50,
      sort: false,
      filters: { archived: 'hide', followed: 'followed', countryCode: country, label_id: zoneId }
    }
  })

  const followedProjects = useMemo(() => followedArtistsResponse?.getCampaigns?.artists?.reduce(
    (acc: IFollowedProjects[], item) => {
      const projects = item.campaigns?.map((project) => ({
        id: project.id ?? '',
        projectName: project.name ?? '',
        ownerId: project.owner_id ?? 0,
        storyCount: notifications.find(({ story }) =>
          story?.campaign_id && project?.id && +story.campaign_id === +project.id)?.ids?.length || 0,
        spotifyId: item.spotify_id ?? '',
        facebookId: item.facebook_id ?? '',
        artistName: item.name ?? ''
      })) ?? []
      return [...acc, ...projects]

    }, []) ?? [], [followedArtistsResponse?.getCampaigns, notifications])

  useLoading({ isLoading: loading })
  useServerError([error])

  return {
    followedProjects
  }
}
